import { ErrorMessage, Field, Form, Formik } from 'formik';
import React, { Component } from 'react';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import * as Yup from 'yup';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';

class RedirectRuleForm extends Component {
  showCard = () => {
    return {
      display: !this.props.isNewRoleRule ? 'none' : '',
    };
  };
  createSchemaForFields = () => {
    const { redirectRoleRule } = this.props;
    const { role, page, successMessage } = redirectRoleRule;
    const schema = {
      role: role || '',
      page: page || '',
      successMessage: successMessage || '',
    };
    return schema;
  };
  validateFields = () => {
    let validationSchema = {
      role: Yup.string().required('Please select a role'),
      page: Yup.string().required('Please select a page'),
    };
    const { events } = this.props;
    const { plugins } = events;
    return Yup.object().shape(validationSchema);
  };
  getPageOption = () => {
    let options = [];
    const { pages } = this.props.events;
    const pageOptions =
      pages.length > 0
        ? pages.map((item, key) => {
            return { value: '/' + item.slug, label: item.name };
          })
        : [];
    return [...options, ...pageOptions];
  };
  getRoleOption = () => {
    let options = [];

    const { roles } = this.props;
    const roleOptions =
      roles.length > 0
        ? roles.map((role, key) => {
            return { value: role.name, label: role.name };
          })
        : [];
    return [...options, ...roleOptions];
  };
  handleSubmit = (values) => {
    console.log('values', values);
    this.props.handleSubmit(values);
  };

  closeAllOpenPopup = (entityToCreate) => {
    this.props.closeAllOpenPopup(entityToCreate);
  };

  render() {
    return (
      <Formik
        enableReinitialize={true}
        initialValues={this.createSchemaForFields()}
        validationSchema={this.validateFields()}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          this.handleSubmit(values);
          setSubmitting(false);
          resetForm();
        }}
      >
        {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
          <Form>
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  {/* <label>{'User Role'}*</label> */}
                  {/* <a
                    onClick={() => this.closeAllOpenPopup('role')}
                    className="direction-custom-link btn btn-outline-secondary"
                    title="Create Role"
                  >
                    <i className="wb webconnect-box-arrow-up-right"></i>&nbsp;Create Role
                  </a> */}
                  <FormFieldWithLabel
                    cta={false}
                    label={'Role'}
                    icon={'select'}
                    infoIcon={true}
                    infoDescription={'Role'}
                  >
                    <CustomSelect
                      key="role"
                      name="role"
                      isMulti={false}
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      options={this.getRoleOption()}
                      value={values['role']}
                      placeholder="Select Role"
                    />
                    <ErrorMessage name={'role'}>
                      {(msg) => <p className="text-error">{msg}</p>}
                    </ErrorMessage>
                  </FormFieldWithLabel>
                  <small style={{ paddingLeft: '13%' }}>
                    Choose a user role previously created.
                  </small>
                </div>
                <div className="form-group">
                  {/* <a
                    onClick={() => this.closeAllOpenPopup('page')}
                    className="direction-custom-link btn btn-outline-secondary"
                    title="Create Page"
                  >
                    <i className="wb webconnect-box-arrow-up-right"></i>&nbsp;Create Page
                  </a> */}
                  <FormFieldWithLabel
                    cta={false}
                    label={'Page'}
                    icon={'select'}
                    infoIcon={true}
                    infoDescription={'Page'}
                  >
                    <CustomSelect
                      key="page"
                      name="page"
                      isMulti={false}
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      options={this.getPageOption()}
                      value={values['page']}
                      placeholder="Select Page"
                    />
                    <ErrorMessage name={'page'}>
                      {(msg) => <p className="text-error">{msg}</p>}
                    </ErrorMessage>
                  </FormFieldWithLabel>
                  <small style={{ paddingLeft: '13%' }}>
                    Choose a page you want users of above selected role to land after logging in.
                  </small>
                </div>

                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label={'Success Message'}
                    icon={'text'}
                    infoIcon={true}
                    infoDescription={'Success Messagele'}
                  >
                    <Field
                      type="text"
                      name="successMessage"
                      className="form-control form-control-sm"
                      autoComplete="off"
                      value={values['successMessage']}
                      placeholder="Success Message"
                    />
                    <ErrorMessage name="successMessage">
                      {(msg) => <p className="texterror">{msg}</p>}
                    </ErrorMessage>
                  </FormFieldWithLabel>
                </div>
              </div>
            </div>
            {this.props.children}
          </Form>
        )}
      </Formik>
    );
  }
}

export default RedirectRuleForm;
